var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("\n        基础信息\n    ")]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务名称", prop: "taskName" } },
        [
          _c("el-input", {
            staticStyle: { width: "500px" },
            attrs: { maxlength: "30", "show-word-limit": "" },
            model: {
              value: _vm.form.taskName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "taskName", $$v)
              },
              expression: "form.taskName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动简介", prop: "taskTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "500px" },
            model: {
              value: _vm.form.taskTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "taskTitle", $$v)
              },
              expression: "form.taskTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "标签", prop: "taskLabel" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            attrs: { maxlength: "4", "show-word-limit": "" },
            model: {
              value: _vm.form.taskLabel,
              callback: function ($$v) {
                _vm.$set(_vm.form, "taskLabel", $$v)
              },
              expression: "form.taskLabel",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务类型" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "250px" },
              attrs: { placeholder: "请选择任务类型" },
              model: {
                value: _vm.form.taskType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "taskType", $$v)
                },
                expression: "form.taskType",
              },
            },
            _vm._l(_vm.typeOptions, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.taskTypeName, value: String(item.id) },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "帖子类型" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.userScope,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "userScope", $$v)
                },
                expression: "form.userScope",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("仅员工")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("仅会员")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 3 } }, [_vm._v("全部")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.userScope == 3 || _vm.form.userScope == 2
        ? _c(
            "el-form-item",
            { attrs: { label: "用户等级" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.memberLevel,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "memberLevel", $$v)
                    },
                    expression: "form.memberLevel",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: 1 } }, [_vm._v("普卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 2 } }, [_vm._v("银卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 3 } }, [_vm._v("金卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 4 } }, [
                    _vm._v("黑金卡"),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 5 } }, [
                    _vm._v("钻石卡"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.form.userScope == 3 || _vm.form.userScope == 2
        ? _c(
            "el-form-item",
            { attrs: { label: "用户是否企微" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.enterpriseWechat,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "enterpriseWechat", $$v)
                    },
                    expression: "form.enterpriseWechat",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动时间", prop: "time" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.validType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "validType", $$v)
                },
                expression: "form.validType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("长期活动")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("固定有效期")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.validType == 1
            ? _c("el-date-picker", {
                staticStyle: { display: "block" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "任务要求", prop: "taskRequirement" } },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.taskRequirement,
                expression: "form.taskRequirement",
              },
            ],
            staticStyle: { width: "700px" },
            attrs: { name: "", id: "" },
            domProps: { value: _vm.form.taskRequirement },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "taskRequirement", $event.target.value)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "活动规则", prop: "taskRule" } }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.taskRule,
              expression: "form.taskRule",
            },
          ],
          staticStyle: { width: "700px" },
          attrs: { name: "", id: "" },
          domProps: { value: _vm.form.taskRule },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "taskRule", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "主图", prop: "mainImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "http-request": function (opt) {
                  return _vm.handleCustomUpload(opt, "main")
                },
                limit: 1,
                "on-remove": function (file, fileList) {
                  return _vm.handleUploadRemove("main", file, fileList)
                },
                "list-type": "picture-card",
                "auto-upload": true,
                accept: "image/*",
                "file-list": _vm.fileList,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(200px * 200px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Banner图", prop: "detailImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "http-request": function (opt) {
                  return _vm.handleCustomUpload(opt, "banner")
                },
                limit: 5,
                "on-remove": function (file, fileList) {
                  return _vm.handleUploadRemove("banner", file, fileList)
                },
                "list-type": "picture-card",
                "auto-upload": true,
                accept: "image/*",
                "file-list": _vm.fileList4,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(750px * 400px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "详情图", prop: "detailImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "http-request": function (opt) {
                  return _vm.handleCustomUpload(opt, "detail")
                },
                limit: 5,
                "on-remove": function (file, fileList) {
                  return _vm.handleUploadRemove("detail", file, fileList)
                },
                "list-type": "picture-card",
                "auto-upload": true,
                accept: "image/*",
                "file-list": _vm.fileList2,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "分享卡片", prop: "shareImage" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "http-request": function (opt) {
                  return _vm.handleCustomUpload(opt, "share")
                },
                limit: 1,
                "on-remove": function (file, fileList) {
                  return _vm.handleUploadRemove("share", file, fileList)
                },
                "list-type": "picture-card",
                "auto-upload": true,
                accept: "image/*",
                "file-list": _vm.fileList3,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(500px * 400px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "分享标题", prop: "shareTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.shareTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "shareTitle", $$v)
              },
              expression: "form.shareTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动状态" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未启用")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "排序", prop: "taskSort" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.taskSort,
              callback: function ($$v) {
                _vm.$set(_vm.form, "taskSort", $$v)
              },
              expression: "form.taskSort",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("\n        基础奖励审核设置\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { margin: "0 20px 10px", color: "red" } }, [
        _vm._v(
          "机审匹配规则：1、话题数量\n        2、内容字数\n        3、链接相似度>80%、链接是否为小红书链接、是否复重复\n        4、内容合规（敏感词库）"
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "关键词" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.keywordList,
              callback: function ($$v) {
                _vm.$set(_vm.form, "keywordList", $$v)
              },
              expression: "form.keywordList",
            },
          }),
          _vm._v("（多个用英文,分割不要加#号）\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "匹配个数" } }, [
        _c(
          "div",
          [
            _vm._v("匹配个数>= "),
            _c("el-input", {
              staticStyle: { width: "100px" },
              model: {
                value: _vm.form.keywordCondition,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "keywordCondition", $$v)
                },
                expression: "form.keywordCondition",
              },
            }),
            _vm._v("个"),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "最少内容字数" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.minContentLength,
              callback: function ($$v) {
                _vm.$set(_vm.form, "minContentLength", $$v)
              },
              expression: "form.minContentLength",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励类型" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: !!_vm.form.id },
              on: { change: _vm.onBaseRewardTypeChange },
              model: {
                value: _vm.baseReward.rewardType,
                callback: function ($$v) {
                  _vm.$set(_vm.baseReward, "rewardType", $$v)
                },
                expression: "baseReward.rewardType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("积分")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("优惠券")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 3 } }, [_vm._v("实物")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "奖励内容", disabled: !!_vm.form.id } },
        [
          _vm.baseReward.rewardType == 1
            ? _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: !!_vm.form.id },
                    model: {
                      value: _vm.baseReward.rewardValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseReward, "rewardValue", $$v)
                      },
                      expression: "baseReward.rewardValue",
                    },
                  }),
                  _vm._v("积分\n        "),
                ],
                1
              )
            : _vm.baseReward.rewardType == 3
            ? _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { disabled: !!_vm.form.id },
                    model: {
                      value: _vm.baseReward.rewardValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseReward, "rewardValue", $$v)
                      },
                      expression: "baseReward.rewardValue",
                    },
                  }),
                ],
                1
              )
            : _vm._l(_vm.baseReward.couponList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "margin-bottom": "10px",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "300px", "margin-right": "10px" },
                        attrs: {
                          disabled: !!_vm.form.id,
                          placeholder: "请输入优惠券，支持模糊查询",
                          filterable: "",
                          remote: "",
                          "reserve-keyword": "",
                          "remote-method": _vm.fetchCoupons1,
                          loading: _vm.couponLoading,
                        },
                        model: {
                          value: item.couponId,
                          callback: function ($$v) {
                            _vm.$set(item, "couponId", $$v)
                          },
                          expression: "item.couponId",
                        },
                      },
                      _vm._l(_vm.couponOptions1, function (coupon) {
                        return _c("el-option", {
                          key: coupon.thirdCouponId,
                          attrs: {
                            label: coupon.typeName,
                            value: coupon.thirdCouponId,
                          },
                        })
                      }),
                      1
                    ),
                    _vm._v("\n\n            数量："),
                    _c("el-input", {
                      staticStyle: { width: "50px" },
                      attrs: { disabled: !!_vm.form.id },
                      model: {
                        value: item.quantity,
                        callback: function ($$v) {
                          _vm.$set(item, "quantity", $$v)
                        },
                        expression: "item.quantity",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", [
                      !_vm.form.id
                        ? _c("i", {
                            staticClass: "el-icon-circle-plus-outline",
                            staticStyle: {
                              color: "#589eff",
                              "font-size": "24px",
                              margin: "0 10px",
                            },
                            on: { click: _vm.handleAdd },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.baseReward.couponList &&
                      _vm.baseReward.couponList.length > 1 &&
                      !_vm.form.id
                        ? _c("i", {
                            staticClass: "el-icon-remove-outline",
                            staticStyle: {
                              color: "#589eff",
                              "font-size": "24px",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleReduce(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "限制" } }, [
        _vm.form.validType == 1
          ? _c(
              "div",
              [
                _vm._v("活动期间内"),
                _c("el-input", {
                  staticStyle: { width: "100px" },
                  attrs: { disabled: !!_vm.form.id },
                  model: {
                    value: _vm.form.limitTimes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "limitTimes", $$v)
                    },
                    expression: "form.limitTimes",
                  },
                }),
                _vm._v("次/每人"),
              ],
              1
            )
          : _c(
              "div",
              [
                _c("el-input", {
                  staticStyle: { width: "100px" },
                  model: {
                    value: _vm.form.limitTimes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "limitTimes", $$v)
                    },
                    expression: "form.limitTimes",
                  },
                }),
                _vm._v("次/每月/每人"),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v("优质额外奖励审核")]),
      _vm._v(" "),
      _vm._l(_vm.extraRewards, function (extra, eIndex) {
        return _c(
          "div",
          { key: eIndex, staticClass: "rule-extra-panel" },
          [
            _c(
              "el-form-item",
              { attrs: { label: "奖励名称" } },
              [
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: { disabled: !!_vm.form.id },
                  model: {
                    value: extra.ladderCount,
                    callback: function ($$v) {
                      _vm.$set(extra, "ladderCount", $$v)
                    },
                    expression: "extra.ladderCount",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "奖励类型" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { disabled: !!_vm.form.id },
                    on: {
                      change: function ($event) {
                        return _vm.onExtraRewardTypeChange(extra, $event)
                      },
                    },
                    model: {
                      value: extra.rewardType,
                      callback: function ($$v) {
                        _vm.$set(extra, "rewardType", $$v)
                      },
                      expression: "extra.rewardType",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("积分")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 2 } }, [_vm._v("优惠券")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 3 } }, [_vm._v("实物")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-form-item", { attrs: { label: "奖励内容" } }, [
              extra.rewardType == 1
                ? _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: !!_vm.form.id },
                        model: {
                          value: extra.rewardValue,
                          callback: function ($$v) {
                            _vm.$set(extra, "rewardValue", $$v)
                          },
                          expression: "extra.rewardValue",
                        },
                      }),
                      _vm._v("积分\n            "),
                    ],
                    1
                  )
                : extra.rewardType == 3
                ? _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: !!_vm.form.id },
                        model: {
                          value: extra.rewardValue,
                          callback: function ($$v) {
                            _vm.$set(extra, "rewardValue", $$v)
                          },
                          expression: "extra.rewardValue",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    _vm._l(extra.couponList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-bottom": "10px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "300px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                disabled: !!_vm.form.id,
                                placeholder: "请输入优惠券，支持模糊查询",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.fetchCoupons1,
                                loading: _vm.couponLoading,
                              },
                              model: {
                                value: item.couponId,
                                callback: function ($$v) {
                                  _vm.$set(item, "couponId", $$v)
                                },
                                expression: "item.couponId",
                              },
                            },
                            _vm._l(_vm.couponOptions1, function (coupon) {
                              return _c("el-option", {
                                key: coupon.thirdCouponId,
                                attrs: {
                                  label: coupon.typeName,
                                  value: coupon.thirdCouponId,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v("\n\n                    数量："),
                          _c("el-input", {
                            staticStyle: { width: "50px" },
                            attrs: { disabled: !!_vm.form.id },
                            model: {
                              value: item.quantity,
                              callback: function ($$v) {
                                _vm.$set(item, "quantity", $$v)
                              },
                              expression: "item.quantity",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", [
                            !_vm.form.id
                              ? _c("i", {
                                  staticClass: "el-icon-circle-plus-outline",
                                  staticStyle: {
                                    color: "#589eff",
                                    "font-size": "24px",
                                    margin: "0 10px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCouponToExtra(extra)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            extra.couponList &&
                            extra.couponList.length > 1 &&
                            !_vm.form.id
                              ? _c("i", {
                                  staticClass: "el-icon-remove-outline",
                                  staticStyle: {
                                    color: "#589eff",
                                    "font-size": "24px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeCouponFromExtra(
                                        extra,
                                        index
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { "text-align": "right", "margin-bottom": "10px" },
              },
              [
                !_vm.form.id
                  ? _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: {
                        color: "#589eff",
                        "font-size": "24px",
                        "margin-right": "10px",
                      },
                      on: { click: _vm.addExtraReward },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.extraRewards.length > 1 && !_vm.form.id
                  ? _c("i", {
                      staticClass: "el-icon-remove-outline",
                      staticStyle: { color: "#589eff", "font-size": "24px" },
                      on: {
                        click: function ($event) {
                          return _vm.removeExtraReward(eIndex)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }